// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file crossme.proto (package crossme, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Puzzle, PuzzleIndex } from "./puzzle_pb";
import { file_puzzle } from "./puzzle_pb";
import type { Fill } from "./fill_pb";
import { file_fill } from "./fill_pb";
import type { Game } from "./game_pb";
import { file_game } from "./game_pb";
import type { User } from "./user_pb";
import { file_user } from "./user_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crossme.proto.
 */
export const file_crossme: GenFile = /*@__PURE__*/
  fileDesc("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", [file_puzzle, file_fill, file_game, file_user, file_google_protobuf_timestamp]);

/**
 * @generated from message crossme.GetPuzzleIndexArgs
 */
export type GetPuzzleIndexArgs = Message<"crossme.GetPuzzleIndexArgs"> & {
};

/**
 * Describes the message crossme.GetPuzzleIndexArgs.
 * Use `create(GetPuzzleIndexArgsSchema)` to create a new message.
 */
export const GetPuzzleIndexArgsSchema: GenMessage<GetPuzzleIndexArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 0);

/**
 * @generated from message crossme.GetPuzzleIndexResponse
 */
export type GetPuzzleIndexResponse = Message<"crossme.GetPuzzleIndexResponse"> & {
  /**
   * @generated from field: repeated crossme.PuzzleIndex puzzles = 1;
   */
  puzzles: PuzzleIndex[];
};

/**
 * Describes the message crossme.GetPuzzleIndexResponse.
 * Use `create(GetPuzzleIndexResponseSchema)` to create a new message.
 */
export const GetPuzzleIndexResponseSchema: GenMessage<GetPuzzleIndexResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 1);

/**
 * @generated from message crossme.GetPuzzleByIdArgs
 */
export type GetPuzzleByIdArgs = Message<"crossme.GetPuzzleByIdArgs"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message crossme.GetPuzzleByIdArgs.
 * Use `create(GetPuzzleByIdArgsSchema)` to create a new message.
 */
export const GetPuzzleByIdArgsSchema: GenMessage<GetPuzzleByIdArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 2);

/**
 * @generated from message crossme.GetPuzzleResponse
 */
export type GetPuzzleResponse = Message<"crossme.GetPuzzleResponse"> & {
  /**
   * @generated from field: crossme.Puzzle puzzle = 1;
   */
  puzzle?: Puzzle | undefined;
};

/**
 * Describes the message crossme.GetPuzzleResponse.
 * Use `create(GetPuzzleResponseSchema)` to create a new message.
 */
export const GetPuzzleResponseSchema: GenMessage<GetPuzzleResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 3);

/**
 * @generated from message crossme.NewGameArgs
 */
export type NewGameArgs = Message<"crossme.NewGameArgs"> & {
  /**
   * @generated from field: string puzzle_id = 1;
   */
  puzzleId: string;
};

/**
 * Describes the message crossme.NewGameArgs.
 * Use `create(NewGameArgsSchema)` to create a new message.
 */
export const NewGameArgsSchema: GenMessage<NewGameArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 4);

/**
 * @generated from message crossme.NewGameResponse
 */
export type NewGameResponse = Message<"crossme.NewGameResponse"> & {
  /**
   * @generated from field: crossme.Game game = 1;
   */
  game?: Game | undefined;
};

/**
 * Describes the message crossme.NewGameResponse.
 * Use `create(NewGameResponseSchema)` to create a new message.
 */
export const NewGameResponseSchema: GenMessage<NewGameResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 5);

/**
 * @generated from message crossme.GetGameByIdArgs
 */
export type GetGameByIdArgs = Message<"crossme.GetGameByIdArgs"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message crossme.GetGameByIdArgs.
 * Use `create(GetGameByIdArgsSchema)` to create a new message.
 */
export const GetGameByIdArgsSchema: GenMessage<GetGameByIdArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 6);

/**
 * @generated from message crossme.GetGameResponse
 */
export type GetGameResponse = Message<"crossme.GetGameResponse"> & {
  /**
   * @generated from field: crossme.Game game = 1;
   */
  game?: Game | undefined;

  /**
   * @generated from field: crossme.Puzzle puzzle = 2;
   */
  puzzle?: Puzzle | undefined;
};

/**
 * Describes the message crossme.GetGameResponse.
 * Use `create(GetGameResponseSchema)` to create a new message.
 */
export const GetGameResponseSchema: GenMessage<GetGameResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 7);

/**
 * @generated from message crossme.UploadPuzzleArgs
 */
export type UploadPuzzleArgs = Message<"crossme.UploadPuzzleArgs"> & {
  /**
   * @generated from field: string filename = 1;
   */
  filename: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message crossme.UploadPuzzleArgs.
 * Use `create(UploadPuzzleArgsSchema)` to create a new message.
 */
export const UploadPuzzleArgsSchema: GenMessage<UploadPuzzleArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 8);

/**
 * @generated from message crossme.UploadPuzzleResponse
 */
export type UploadPuzzleResponse = Message<"crossme.UploadPuzzleResponse"> & {
  /**
   * @generated from field: crossme.Puzzle puzzle = 1;
   */
  puzzle?: Puzzle | undefined;
};

/**
 * Describes the message crossme.UploadPuzzleResponse.
 * Use `create(UploadPuzzleResponseSchema)` to create a new message.
 */
export const UploadPuzzleResponseSchema: GenMessage<UploadPuzzleResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 9);

/**
 * @generated from message crossme.SubscribeArgs
 */
export type SubscribeArgs = Message<"crossme.SubscribeArgs"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message crossme.SubscribeArgs.
 * Use `create(SubscribeArgsSchema)` to create a new message.
 */
export const SubscribeArgsSchema: GenMessage<SubscribeArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 10);

/**
 * @generated from message crossme.SubscribeEvent
 */
export type SubscribeEvent = Message<"crossme.SubscribeEvent"> & {
  /**
   * @generated from field: crossme.Fill fill = 1;
   */
  fill?: Fill | undefined;
};

/**
 * Describes the message crossme.SubscribeEvent.
 * Use `create(SubscribeEventSchema)` to create a new message.
 */
export const SubscribeEventSchema: GenMessage<SubscribeEvent> = /*@__PURE__*/
  messageDesc(file_crossme, 11);

/**
 * @generated from message crossme.UpdateFillArgs
 */
export type UpdateFillArgs = Message<"crossme.UpdateFillArgs"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: crossme.Fill fill = 3;
   */
  fill?: Fill | undefined;
};

/**
 * Describes the message crossme.UpdateFillArgs.
 * Use `create(UpdateFillArgsSchema)` to create a new message.
 */
export const UpdateFillArgsSchema: GenMessage<UpdateFillArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 12);

/**
 * @generated from message crossme.UpdateFillResponse
 */
export type UpdateFillResponse = Message<"crossme.UpdateFillResponse"> & {
};

/**
 * Describes the message crossme.UpdateFillResponse.
 * Use `create(UpdateFillResponseSchema)` to create a new message.
 */
export const UpdateFillResponseSchema: GenMessage<UpdateFillResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 13);

/**
 * @generated from message crossme.GetMyGamesArgs
 */
export type GetMyGamesArgs = Message<"crossme.GetMyGamesArgs"> & {
};

/**
 * Describes the message crossme.GetMyGamesArgs.
 * Use `create(GetMyGamesArgsSchema)` to create a new message.
 */
export const GetMyGamesArgsSchema: GenMessage<GetMyGamesArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 14);

/**
 * One entry in the caller's play history: enough to render a row in the
 * "My games" list without further lookups.
 *
 * @generated from message crossme.MyGame
 */
export type MyGame = Message<"crossme.MyGame"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: string puzzle_id = 2;
   */
  puzzleId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string author = 4;
   */
  author: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_played = 5;
   */
  firstPlayed?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_played = 6;
   */
  lastPlayed?: Timestamp | undefined;

  /**
   * Set once the game has been solved; unset while in progress.
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 7;
   */
  completedAt?: Timestamp | undefined;
};

/**
 * Describes the message crossme.MyGame.
 * Use `create(MyGameSchema)` to create a new message.
 */
export const MyGameSchema: GenMessage<MyGame> = /*@__PURE__*/
  messageDesc(file_crossme, 15);

/**
 * @generated from message crossme.GetMyGamesResponse
 */
export type GetMyGamesResponse = Message<"crossme.GetMyGamesResponse"> & {
  /**
   * Most recently played first.
   *
   * @generated from field: repeated crossme.MyGame games = 1;
   */
  games: MyGame[];
};

/**
 * Describes the message crossme.GetMyGamesResponse.
 * Use `create(GetMyGamesResponseSchema)` to create a new message.
 */
export const GetMyGamesResponseSchema: GenMessage<GetMyGamesResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 16);

/**
 * @generated from message crossme.RecordPlaysArgs
 */
export type RecordPlaysArgs = Message<"crossme.RecordPlaysArgs"> & {
  /**
   * @generated from field: repeated crossme.RecordPlaysArgs.Play plays = 1;
   */
  plays: RecordPlaysArgs_Play[];
};

/**
 * Describes the message crossme.RecordPlaysArgs.
 * Use `create(RecordPlaysArgsSchema)` to create a new message.
 */
export const RecordPlaysArgsSchema: GenMessage<RecordPlaysArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 17);

/**
 * @generated from message crossme.RecordPlaysArgs.Play
 */
export type RecordPlaysArgs_Play = Message<"crossme.RecordPlaysArgs.Play"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: google.protobuf.Timestamp played_at = 2;
   */
  playedAt?: Timestamp | undefined;
};

/**
 * Describes the message crossme.RecordPlaysArgs.Play.
 * Use `create(RecordPlaysArgs_PlaySchema)` to create a new message.
 */
export const RecordPlaysArgs_PlaySchema: GenMessage<RecordPlaysArgs_Play> = /*@__PURE__*/
  messageDesc(file_crossme, 17, 0);

/**
 * @generated from message crossme.RecordPlaysResponse
 */
export type RecordPlaysResponse = Message<"crossme.RecordPlaysResponse"> & {
};

/**
 * Describes the message crossme.RecordPlaysResponse.
 * Use `create(RecordPlaysResponseSchema)` to create a new message.
 */
export const RecordPlaysResponseSchema: GenMessage<RecordPlaysResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 18);

/**
 * @generated from message crossme.GetSelfArgs
 */
export type GetSelfArgs = Message<"crossme.GetSelfArgs"> & {
};

/**
 * Describes the message crossme.GetSelfArgs.
 * Use `create(GetSelfArgsSchema)` to create a new message.
 */
export const GetSelfArgsSchema: GenMessage<GetSelfArgs> = /*@__PURE__*/
  messageDesc(file_crossme, 19);

/**
 * @generated from message crossme.GetSelfResponse
 */
export type GetSelfResponse = Message<"crossme.GetSelfResponse"> & {
  /**
   * Unset if the request carried no (valid) session: the caller is
   * anonymous.
   *
   * @generated from field: crossme.User user = 1;
   */
  user?: User | undefined;

  /**
   * The login providers this server offers, by the slug used in
   * /api/auth/{provider}/login ("google", or "crossme" on a preview
   * that signs users in through production). Empty means accounts are
   * off and the client should offer no sign-in.
   *
   * @generated from field: repeated string login_providers = 2;
   */
  loginProviders: string[];
};

/**
 * Describes the message crossme.GetSelfResponse.
 * Use `create(GetSelfResponseSchema)` to create a new message.
 */
export const GetSelfResponseSchema: GenMessage<GetSelfResponse> = /*@__PURE__*/
  messageDesc(file_crossme, 20);

/**
 * @generated from service crossme.CrossMe
 */
export const CrossMe: GenService<{
  /**
   * @generated from rpc crossme.CrossMe.GetPuzzleIndex
   */
  getPuzzleIndex: {
    methodKind: "unary";
    input: typeof GetPuzzleIndexArgsSchema;
    output: typeof GetPuzzleIndexResponseSchema;
  },
  /**
   * @generated from rpc crossme.CrossMe.GetPuzzleById
   */
  getPuzzleById: {
    methodKind: "unary";
    input: typeof GetPuzzleByIdArgsSchema;
    output: typeof GetPuzzleResponseSchema;
  },
  /**
   * @generated from rpc crossme.CrossMe.NewGame
   */
  newGame: {
    methodKind: "unary";
    input: typeof NewGameArgsSchema;
    output: typeof NewGameResponseSchema;
  },
  /**
   * @generated from rpc crossme.CrossMe.GetGameById
   */
  getGameById: {
    methodKind: "unary";
    input: typeof GetGameByIdArgsSchema;
    output: typeof GetGameResponseSchema;
  },
  /**
   * @generated from rpc crossme.CrossMe.UploadPuzzle
   */
  uploadPuzzle: {
    methodKind: "unary";
    input: typeof UploadPuzzleArgsSchema;
    output: typeof UploadPuzzleResponseSchema;
  },
  /**
   * @generated from rpc crossme.CrossMe.UpdateFill
   */
  updateFill: {
    methodKind: "unary";
    input: typeof UpdateFillArgsSchema;
    output: typeof UpdateFillResponseSchema;
  },
  /**
   * @generated from rpc crossme.CrossMe.Subscribe
   */
  subscribe: {
    methodKind: "server_streaming";
    input: typeof SubscribeArgsSchema;
    output: typeof SubscribeEventSchema;
  },
  /**
   * Who am I? Resolves the caller's session cookie; the session
   * itself is managed by the HTTP endpoints under /api/auth/.
   *
   * @generated from rpc crossme.CrossMe.GetSelf
   */
  getSelf: {
    methodKind: "unary";
    input: typeof GetSelfArgsSchema;
    output: typeof GetSelfResponseSchema;
  },
  /**
   * The games the signed-in caller has played, most recent first.
   * Anonymous callers have no server-side history and get an empty
   * list.
   *
   * @generated from rpc crossme.CrossMe.GetMyGames
   */
  getMyGames: {
    methodKind: "unary";
    input: typeof GetMyGamesArgsSchema;
    output: typeof GetMyGamesResponseSchema;
  },
  /**
   * Merge a batch of plays into the signed-in caller's history. The
   * client uses this to fold the browser-local "recent games" list —
   * in particular, games played before signing in — into the account.
   * Merging is idempotent: replayed entries only ever widen a game's
   * first/last-played window. A no-op for anonymous callers.
   *
   * @generated from rpc crossme.CrossMe.RecordPlays
   */
  recordPlays: {
    methodKind: "unary";
    input: typeof RecordPlaysArgsSchema;
    output: typeof RecordPlaysResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crossme, 0);

